import { useAuth } from "@sal/authentication.react";
import { usePageTabTitle, usePortalApplicationContext } from "@sal/onevent-portal";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PageLayout } from "../components/PageLayout";

export function LogoutPage() {
	const auth = useAuth();
	const navigate = useNavigate();
	const { organisations } = usePortalApplicationContext();
	const queryClient = useQueryClient();
	usePageTabTitle({ title: "Logout" });

	const { authenticationMethod, logout } = auth;
	const loginPath = authenticationMethod === "SalCore" ? "/Login" : "/SingleSignOn/Microsoft";

	useEffect(() => {
		queryClient.clear();
		logout(() => {
			organisations.clearOrganisations();
			navigate(loginPath, { replace: true });
		});
	}, [loginPath, logout, navigate, organisations, queryClient]);

	return (
		<PageLayout title={"Logout"}>
			<div>Logging out...</div>
		</PageLayout>
	);
}
